<app-section-header surtitle="Paiement" title="Paiements"></app-section-header>

<div class="payer-content">
  <p class="lead">
    Nous acceptons les paiements par chèque et en espèces directement à notre
    établissement.
  </p>

  <div class="payment-methods">
    <div class="payment-method">
      <mat-icon>account_balance_wallet</mat-icon>
      <span class="payment-method__name">Chèque</span>
    </div>
    <div class="payment-method">
      <mat-icon>euro_symbol</mat-icon>
      <span class="payment-method__name">Espèces</span>
    </div>
  </div>
</div>
